import { useDelete } from '@refinedev/core';

export function useDeleteSuitabilityReport() {
  const { mutateAsync, error, isLoading, reset } = useDelete();

  const deleteSuitabilityReport = async (clientId: string, reportId: string) => {
    return mutateAsync({
      resource: `clients/${clientId}/suitability-reports`,
      id: reportId,
    });
  };

  return {
    deleteSuitabilityReport,
    error,
    isLoading,
    reset,
  };
}
